import { render, staticRenderFns } from "./PaymentDetailsForm.vue?vue&type=template&id=0d53129e&scoped=true"
import script from "./PaymentDetailsForm.vue?vue&type=script&lang=ts"
export * from "./PaymentDetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDetailsForm.vue?vue&type=style&index=0&id=0d53129e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53129e",
  null
  
)

export default component.exports